<template>
  <div v-if="activeLanguages.length > 1">
    <v-menu offset-y>
      <template #activator="{on}">
        <v-btn
          :class="{'brand-beige': $vuetify.breakpoint.smAndDown}"
          :name="$t('Common.Misc.Locale')"
          class="brand-green-dark--text"
          color="brand-green-dark"
          dark
          depressed
          icon
          large
          style="min-width: 0;"
          v-on="on"
        >
          <v-icon v-if="$vuetify.breakpoint.smAndDown">
            mdi-web
          </v-icon>
          <div
            v-else
            class="lang-selector-text lang-selector-selected"
          >
            {{ lang.short_name }}
            <div style="width: 100%; border-bottom: var(--v-brand-green-dark-base) 2px solid" />
          </div>
        </v-btn>
      </template>

      <v-list
        class="pa-0 ma-0"
        color="brand-card-bg"
        dense
      >
        <template v-for="lng in activeLanguages">
          <v-list-item
            :key="`list-item-${lng.locale}`"
            :disabled="lng.locale === lang.locale"
            @click="switchLanguage(lng)"
          >
            <v-list-item-content>
              <v-list-item-title>
                <span class="lang-selector-text lang-selector-list-title">{{ lng.short_name }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="`list-item-divider-${lng.locale}`" />
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import LangSwitchMixin from '@/theme/default/components/widgets/LangSwitch.js'

export default {
  name  : 'LangSwitch',
  mixins: [LangSwitchMixin],
  props : {
    size: {
      type   : [String, Number],
      default: '24'
    }
  }
}
</script>

<style scoped src="@/theme/default/components/widgets/LangSwitch.css"></style>

<style scoped>
.lang-selector-text {
  font-family: 'PF DIN Text Comp Pro';
  font-weight: 500;
  line-height: 22px;
}

.lang-selector-selected {
  font-size: 25px;
}

.lang-selector-list-title {
  font-size: 22px;
}

.v-menu__content {
  box-shadow: unset !important;
}
</style>
